var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
export const submitMessageToLivePerson = ({
  requestOptions: {
    url = '',
    headers = {}
  },
  livePersonMessagePayload,
  handleLivePersonOnMessageError
}) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    const result = yield fetch(url, {
      method: 'POST',
      body: JSON.stringify(livePersonMessagePayload),
      headers: Object.assign({
        'Content-Type': 'application/json'
      }, headers)
    });
    const json = yield result.json();
    if (json.status === 200) {
      // livePerson will return nothing back if resquest success,
      // we will get response only through SSE subscription
      return {};
    }
  } catch (err) {
    handleLivePersonOnMessageError(`
      Submit Message err:
      message: ${err.message}
      stack: ${err === null || err === void 0 ? void 0 : err.stack}
    `);
    const error = {
      errorMessage: 'Sorry, system errors occur.'
    };
    return error;
  }
});